import { createApp } from 'vue'

import App from './App.vue'
import router from './router'
import store from './store';
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import i18n from '@/lang/index' // 多语言引入
import contextmenu from "v-contextmenu";
import "v-contextmenu/dist/themes/default.css";

import VMdPreview from '@kangc/v-md-editor/lib/preview';
import '@kangc/v-md-editor/lib/style/preview.css';
import githubTheme from '@kangc/v-md-editor/lib/theme/github.js';
import '@kangc/v-md-editor/lib/theme/style/github.css';
import { QWebChannel } from '@/webBridge/qwebchannel.js'

import { startTokenWorker, sendNewTokenToWorker, stopTokenWorker } from './tokenWorker';

export var qtWebChannel = null;  //导出qtWebChannel，供其他页面调用

//设置主题：'light'(明)  'dark'(暗)
export const setTheme = (type) =>{
  window.document.documentElement.setAttribute('data-theme', type);
}

//设置语言：'zh-CN'(中文) 'en-US'(英文)
export const setLanguage = (lang) =>
{
  localStorage.setItem('lang', lang);
}

// new QWebChannel(qt.webChannelTransport, (channel) => {
//     qtWebChannel = channel.objects.core;

//     qtWebChannel.webInitial.connect((response) => {
//       let result = JSON.parse(response);
//       setTheme(result.theme);
//       setLanguage(result.language);
//     });
  
//     qtWebChannel.themeChanged.connect((response) => {
//       setTheme(response);
//     });
//   });

// highlightjs
import hljs from 'highlight.js';

VMdPreview.use(githubTheme, {
  Hljs: hljs,
});

document.title = 'ZW Assistant'; 

const app = createApp(App);

app.use(ElementPlus).use(router).use(store).use(i18n).use(contextmenu).use(VMdPreview);
app.config.globalProperties.$t = i18n.global.t;

app.mount('#app');

// // 创建并启动 token Worker
// //startTokenWorker( 5 * 60 * 1000);
// startTokenWorker(10 * 1000);

// // 在程序关闭时销毁 token Worker
//  window.addEventListener('beforeunload', () => {
//    stopTokenWorker();
//  });